(function () {
  'use strict';

  const COUPON_KEY = 'demetos_applied_coupon';

  const ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13"/><path d="M12 8S11 3 8.5 3a2.5 2.5 0 0 0 0 5H12zM12 8s1-5 3.5-5a2.5 2.5 0 0 1 0 5H12z"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="var(--sh-green)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="17" height="17"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.2" fill="var(--sh-green)" stroke="none"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l1.9 6.1L20 10l-6.1 1.9L12 18l-1.9-6.1L4 10l6.1-1.9z"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>',
    receipt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M5 3v18l2.5-1.8L10 21l2-1.8L14 21l2.5-1.8L19 21V3H5z"/><path d="M9 8h6M9 12h6"/></svg>',
  };

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && CONFIG.moneyFormat) {
      return window.Shopify.formatMoney(cents, CONFIG.moneyFormat);
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  function loadConfig() {
    const el = document.getElementById('demetos-cart-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[demetos-cart] invalid config', e);
      return null;
    }
  }

  let CONFIG = loadConfig();
  if (!CONFIG) return;

  const els = {
    root: document.getElementById('demetos-cart-root'),
    overlay: document.getElementById('demetosCartOverlay'),
    drawer: document.getElementById('demetosCartDrawer'),
    inner: document.getElementById('demetosCartInner'),
    toast: document.getElementById('demetosCartToast'),
  };
  if (!els.root || !els.inner) return;

  els.root.hidden = false;

  const state = {
    cart: null,
    offersOpen: false,
    couponCode: null,
    couponError: '',
    loading: false,
  };

  try {
    state.couponCode = sessionStorage.getItem(COUPON_KEY) || null;
  } catch (e) {
    state.couponCode = null;
  }

  function tierRewards(subtotalRupees, tiers) {
    let freeship = false;
    let gift = false;
    let giftName = '';
    let percent = 0;
    for (const t of tiers) {
      if (subtotalRupees >= t.amount) {
        if (t.reward === 'freeship') freeship = true;
        if (t.reward === 'gift') {
          gift = true;
          giftName = t.giftName || 'Free gift';
        }
        if (t.reward === 'percent') percent = t.value || 0;
      }
    }
    return { freeship, gift, giftName, percent };
  }

  function progressView(subtotalRupees, tiers) {
    const n = tiers.length;
    const seg = n > 1 ? 100 / (n - 1) : 100;
    const first = tiers[0]?.amount || 0;
    let pct = 0;
    if (subtotalRupees > first && n >= 2) {
      for (let i = 0; i < n - 1; i++) {
        const a = tiers[i].amount;
        const b = tiers[i + 1].amount;
        if (subtotalRupees < b) {
          pct = i * seg + ((subtotalRupees - a) / (b - a)) * seg;
          break;
        }
        if (i === n - 2) pct = 100;
      }
    }
    let next = null;
    for (const t of tiers) {
      if (subtotalRupees < t.amount) {
        next = t;
        break;
      }
    }
    const message = next
      ? next.code
        ? 'Add <b>₹' +
          Math.ceil(next.amount - subtotalRupees) +
          '</b> more · use code <b>' +
          esc(next.code) +
          '</b> — ' +
          esc(next.label)
        : 'Add <b>₹' +
          Math.ceil(next.amount - subtotalRupees) +
          '</b> more to unlock <b>' +
          esc(next.label) +
          '</b>'
      : 'You’ve unlocked <b>all Diwali rewards</b> — apply your code at checkout!';
    const nodes = tiers.map((tr, i) => ({
      amount: tr.amount,
      label: tr.label,
      code: tr.code || '',
      reached: subtotalRupees >= tr.amount,
      at: i * seg,
    }));
    return { pct: pct.toFixed(3), message, nodes };
  }

  function findCoupon(code) {
    if (!code) return null;
    const up = code.trim().toUpperCase();
    return (CONFIG.coupons || []).find((c) => c.code.toUpperCase() === up) || null;
  }

  function couponUsable(c, subtotalRupees) {
    if (!c) return false;
    if (c.tag === 'welcome' && !CONFIG.customerEmail) return false;
    return subtotalRupees >= (c.minCart || 0);
  }

  function bundleMeta(line) {
    const map = CONFIG.bundleVariants || {};
    return map[String(line.variant_id)] || null;
  }

  function isBundleLine(line) {
    if (bundleMeta(line)) return true;
    const propType = line.properties && line.properties['Product type'];
    if (propType && String(propType).toLowerCase().includes('combo')) return true;
    if (propType && String(propType).toLowerCase().includes('bundle')) return true;
    const pt = (line.product_type || '').toLowerCase();
    if (pt.includes('combo') || pt.includes('bundle')) return true;
    return false;
  }

  function eligibleDiscountCents(lines) {
    let cents = 0;
    lines.forEach((line) => {
      if (!isBundleLine(line)) cents += line.final_line_price;
    });
    return cents;
  }

  function lineMrpCents(line) {
    const compareUnit = line.compare_at_price;
    if (compareUnit && compareUnit > (line.final_price || line.price)) {
      return compareUnit * line.quantity;
    }
    const original = line.original_line_price;
    if (original && original > line.final_line_price) return original;
    return line.final_line_price;
  }

  /** Active automatic / code discounts from Shopify (line allocations once; no cart+line double count). */
  function collectCouponDiscountRows(cart) {
    const byTitle = new Map();
    let lineAllocSum = 0;
    (cart.items || []).forEach((line) => {
      (line.line_level_discount_allocations || []).forEach((alloc) => {
        const amt = alloc.amount || 0;
        if (amt <= 0) return;
        lineAllocSum += amt;
        const title = alloc.discount_application?.title || alloc.title || 'Discount';
        byTitle.set(title, (byTitle.get(title) || 0) + amt);
      });
    });
    if (lineAllocSum > 0) {
      return Array.from(byTitle.entries()).map(([title, amountCents]) => ({ title, amountCents }));
    }
    (cart.cart_level_discount_applications || []).forEach((app) => {
      const amt = app.total_allocated_amount || 0;
      if (amt > 0) byTitle.set(app.title || 'Discount', amt);
    });
    return Array.from(byTitle.entries()).map(([title, amountCents]) => ({ title, amountCents }));
  }

  function computeTotals(cart) {
    const lines = cart.items || [];
    let subtotalCents = 0;
    let mrpSubtotalCents = 0;
    let count = 0;
    lines.forEach((line) => {
      subtotalCents += line.final_line_price;
      mrpSubtotalCents += lineMrpCents(line);
      count += line.quantity;
    });
    const subtotalRupees = subtotalCents / 100;
    const discountableCents = eligibleDiscountCents(lines);
    const discountableRupees = discountableCents / 100;
    const tiers = CONFIG.progressTiers || [];
    const { freeship, gift, giftName, percent } = tierRewards(discountableRupees, tiers);

    let couponObj = null;
    let couponDiscountCents = 0;
    const c = findCoupon(state.couponCode);
    if (c && couponUsable(c, discountableRupees)) {
      couponObj = c;
      couponDiscountCents =
        c.type === 'percent'
          ? Math.round(discountableCents * c.value / 100)
          : Math.min(Math.round(c.value * 100), discountableCents);
    }

    const couponDiscountLines = collectCouponDiscountRows(cart);
    const couponDiscountFromShopify = couponDiscountLines.reduce((s, d) => s + d.amountCents, 0);
    const saleSavingsCents = Math.max(0, mrpSubtotalCents - subtotalCents - couponDiscountFromShopify);
    const totalCents =
      typeof cart.total_price === 'number' ? cart.total_price : subtotalCents;
    const totalSavingsCents = Math.max(0, mrpSubtotalCents - totalCents);

    return {
      count,
      subtotalCents,
      mrpSubtotalCents,
      subtotalRupees,
      discountableCents,
      discountableRupees,
      freeship,
      gift,
      giftName,
      percent,
      couponDiscountCents,
      couponObj,
      couponDiscountLines,
      couponDiscountFromShopify,
      saleSavingsCents,
      totalCents,
      totalSavingsCents,
      hasBundle: lines.some(isBundleLine),
    };
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Could not load cart');
    state.cart = await res.json();
    return state.cart;
  }

  function updateBadge(count) {
    const fab = document.getElementById('demetos-cart-fab');
    if (!fab) return;
    const badge = fab.querySelector('.sh-fab-badge');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('show', count > 0);
  }

  function toast(html) {
    if (!els.toast) return;
    els.toast.innerHTML = html;
    els.toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => els.toast.classList.remove('show'), 2800);
  }

  function renderProgress(t) {
    const tiers = CONFIG.progressTiers || [];
    const progressRupees = t.discountableRupees != null ? t.discountableRupees : (t.discountableCents || 0) / 100;
    if (!tiers.length || progressRupees <= 0) return '';
    const view = progressView(progressRupees, tiers);
    let nodes = '';
    view.nodes.forEach((n) => {
      nodes +=
        '<div class="sh-node' +
        (n.reached ? ' reached' : '') +
        '" style="left:' +
        n.at +
        '%">' +
        '<span class="dot">' +
        ICON.check +
        '</span>' +
        '<span class="cap"><b>₹' +
        n.amount +
        '</b><br>' +
        esc(n.label) +
        '</span></div>';
    });
    return (
      '<div class="sh-progress"><div class="sh-progress-msg">' +
      view.message +
      '</div><div class="sh-progress-track"><div class="sh-progress-fill" style="width:' +
      view.pct +
      '%"></div>' +
      nodes +
      '</div></div>'
    );
  }

  function renderUpsell(cart) {
    const inCart = new Set((cart.items || []).map((i) => i.variant_id));
    const picks = (CONFIG.upsellCandidates || [])
      .filter((p) => p.variantId && !inCart.has(p.variantId))
      .slice(0, 6);
    if (!picks.length) return '';
    const cards = picks
      .map(
        (p) =>
          '<div class="sh-up-card">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') +
          '<button type="button" class="sh-up-add" data-act="up-add" data-variant-id="' +
          p.variantId +
          '" aria-label="Add ' +
          esc(p.title) +
          '">+</button>' +
          '<div class="sh-up-name">' +
          esc(p.title) +
          '</div>' +
          '<div class="sh-up-price">' +
          money(p.price) +
          '</div></div>'
      )
      .join('');
    return '<div class="sh-sec"><div class="sh-sec-title">GOES WELL WITH</div><div class="sh-upsell-row">' + cards + '</div></div>';
  }

  function renderCouponSection(t) {
    const coupons = CONFIG.coupons || [];
    if (!coupons.length) return '';

    let h = '<div class="sh-sec"><div class="sh-sec-title">OFFERS</div>';
    if (t.couponObj) {
      h +=
        '<div class="sh-coupon-applied">' +
        ICON.check +
        '<span><span class="tag">' +
        esc(t.couponObj.code) +
        '</span> applied · saved ' +
        money(t.couponDiscountCents) +
        '</span><button type="button" data-act="rm-coupon">REMOVE</button></div>';
    } else {
      h +=
        '<div class="sh-coupon-input"><input id="demetosCouponField" placeholder="Have a coupon code?" autocomplete="off">' +
        '<button type="button" data-act="apply-input">APPLY</button></div>' +
        '<div class="sh-coupon-err">' +
        esc(state.couponError) +
        '</div>';
    }
    if (!CONFIG.customerEmail && coupons.some((c) => c.tag === 'welcome')) {
      h +=
        '<div class="sh-signin"><div class="sh-signin-ic">' +
        ICON.gift +
        '</div><div class="sh-signin-txt"><b>Get 10% off</b> your first order — sign in to unlock.</div>' +
        '<a class="sh-signin-cta" href="' +
        esc(CONFIG.loginUrl) +
        '">Sign in</a></div>';
    } else if (CONFIG.customerEmail) {
      h +=
        '<div class="sh-signin is-in"><div class="sh-signin-ic">' +
        ICON.check +
        '</div><div class="sh-signin-txt">Signed in as <b>' +
        esc(CONFIG.customerEmail) +
        '</b></div></div>';
    }
    return h + '</div>';
  }

  function renderFoot(t) {
    let h = '<div class="sh-foot">';
    const showMrpBreakdown =
      t.mrpSubtotalCents > t.subtotalCents + 1 ||
      (t.couponDiscountLines && t.couponDiscountLines.length > 0);

    if (showMrpBreakdown) {
      h +=
        '<div class="sh-row"><span>Subtotal (MRP)</span><span>' +
        money(t.mrpSubtotalCents) +
        '</span></div>';
      if (t.saleSavingsCents > 0) {
        h +=
          '<div class="sh-row save"><span>Sale vs MRP</span><span>−' +
          money(t.saleSavingsCents) +
          '</span></div>';
      }
      (t.couponDiscountLines || []).forEach((d) => {
        h +=
          '<div class="sh-row save"><span>Coupon · ' +
          esc(d.title) +
          '</span><span>−' +
          money(d.amountCents) +
          '</span></div>';
      });
    } else {
      h += '<div class="sh-row"><span>Subtotal</span><span>' + money(t.subtotalCents) + '</span></div>';
    }
    h +=
      '<div class="sh-row sh-row-shipping"><span>Shipping</span><span class="sh-shipping-note">Calculated at checkout</span></div>';
    h +=
      '<div class="sh-total"><div class="sh-row total"><span>Total</span><span>' +
      money(t.totalCents) +
      '</span></div>';
    if (t.totalSavingsCents > 0)
      h +=
        '<div class="sh-saveline">' +
        ICON.spark +
        'You save ' +
        money(t.totalSavingsCents) +
        ' on this order</div>';
    h += '</div>';
    h +=
      '<button type="button" class="sh-checkout" data-act="checkout"' +
      (t.count ? '' : ' disabled') +
      '>' +
      ICON.lock +
      'Proceed to Checkout</button>';
    h += '<div class="sh-trust">Secure checkout · Cash on Delivery available</div></div>';
    return h;
  }

  function render() {
    if (!state.cart) return;
    const cart = state.cart;
    const t = computeTotals(cart);
    updateBadge(t.count);

    const prevScroll = els.inner.querySelector('.sh-scroll');
    const savedY = prevScroll ? prevScroll.scrollTop : 0;

    let html =
      '<div class="sh-drawer-head">' +
      '<div><div class="sh-drawer-title">Your Cart</div>' +
      '<div class="sh-drawer-count">' +
      (t.count ? t.count + (t.count > 1 ? ' items' : ' item') : 'empty') +
      '</div></div>' +
      '<div class="sh-head-actions">' +
      '<a class="sh-head-orders" href="' +
      esc(CONFIG.ordersUrl) +
      '" aria-label="View my orders">' +
      ICON.receipt +
      '<span>Orders</span></a>' +
      '<button type="button" class="sh-close" data-act="close" aria-label="Close cart">' +
      ICON.x +
      '</button></div></div>';

    if (!t.count) {
      html +=
        '<div class="sh-scroll"><div class="sh-empty">' +
        ICON.cart +
        '<h4>Your cart is empty</h4><p>Add some bold snacks to get started.</p>' +
        '<a class="sh-empty-btn" href="' +
        esc(CONFIG.shopUrl) +
        '" data-act="close">Start shopping</a></div></div>';
      els.inner.innerHTML = html;
      return;
    }

    html += renderProgress(t);
    html += '<div class="sh-scroll"><div class="sh-items">';
    (cart.items || []).forEach((line) => {
      const bundle = isBundleLine(line);
      const meta = bundleMeta(line);
      const propType = (line.properties && line.properties['Product type']) || meta?.productType || line.product_type || 'Demetos';
      const packFromProp = line.properties && (line.properties['Pack contents'] || line.properties['Items to pack']);
      const packContents = packFromProp || meta?.packContents || '';
      const compareUnit = line.compare_at_price || line.original_price || 0;
      const compareLineCents =
        compareUnit > (line.final_price || line.price)
          ? compareUnit * line.quantity
          : line.original_line_price > line.final_line_price
            ? line.original_line_price
            : 0;

      let totalCol =
        '<div class="sh-line-total">' + money(line.final_line_price);
      if (bundle && compareLineCents > line.final_line_price) {
        totalCol += '<s>' + money(compareLineCents) + '</s>';
      }
      totalCol += '</div>';

      html +=
        '<div class="sh-line' +
        (bundle ? ' is-bundle' : '') +
        '">' +
        (line.image
          ? '<img class="sh-line-img" src="' + esc(line.image) + '" alt="" loading="lazy">'
          : '<div class="sh-line-img"></div>') +
        '<div class="sh-line-main"><div class="sh-line-badges"><span class="sh-line-type">' +
        esc(propType) +
        '</span></div><div class="sh-line-name">' +
        esc(line.product_title) +
        (line.variant_title && line.variant_title !== 'Default Title' ? ' · ' + esc(line.variant_title) : '') +
        '</div>';
      if (bundle) {
        html +=
          '<p class="sh-line-note">This product is already at its best price — extra cart discounts do not apply.</p>';
      }
      if (packContents) {
        html += '<div class="sh-line-pack"><span class="sh-line-pack-h">Pack</span> ' + esc(packContents) + '</div>';
      }
      html +=
        '<div class="sh-line-row"><div class="sh-qty">' +
        '<button type="button" data-act="dec" data-key="' +
        esc(line.key) +
        '" aria-label="Decrease">−</button><span>' +
        line.quantity +
        '</span><button type="button" data-act="inc" data-key="' +
        esc(line.key) +
        '" aria-label="Increase">+</button></div>' +
        '<button type="button" class="sh-line-rm" data-act="rm" data-key="' +
        esc(line.key) +
        '">Remove</button></div></div>' +
        totalCol +
        '</div>';
    });
    if (t.gift) {
      html +=
        '<div class="sh-line gift"><div class="sh-line-img">' +
        ICON.gift +
        '</div><div class="sh-line-main"><div class="sh-line-cat">REWARD UNLOCKED</div><div class="sh-line-name">' +
        esc(t.giftName) +
        '</div></div><div class="sh-line-free">FREE</div></div>';
    }
    html += '</div>';
    html += renderUpsell(cart);
    html += renderCouponSection(t);
    html += '</div>';
    html += renderFoot(t);

    els.inner.innerHTML = html;
    const ns = els.inner.querySelector('.sh-scroll');
    if (ns) ns.scrollTop = savedY;
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || 'Could not update cart');
    state.cart = data;
    render();
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  async function addItems(items) {
    const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || 'Could not add to cart');
    await fetchCart();
    render();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    return data;
  }

  function openDrawer() {
    document.body.classList.add('demetos-cart-open');
    els.overlay.classList.add('open');
    els.drawer.classList.add('open');
    els.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    els.overlay.classList.remove('open');
    els.drawer.classList.remove('open');
    els.overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('demetos-cart-open');
    document.body.style.overflow = '';
  }

  function applyCoupon(code) {
    const c = findCoupon(code);
    if (!c) {
      state.couponError = 'Invalid coupon code';
      render();
      return;
    }
    const t = computeTotals(state.cart);
    if (!couponUsable(c, t.subtotalRupees)) {
      state.couponError = c.tag === 'welcome' && !CONFIG.customerEmail ? 'Sign in to unlock' : 'Coupon not applicable';
      render();
      return;
    }
    state.couponCode = c.code;
    state.couponError = '';
    try {
      sessionStorage.setItem(COUPON_KEY, c.code);
    } catch (e) {}
    render();
  }

  function removeCoupon() {
    state.couponCode = null;
    state.couponError = '';
    try {
      sessionStorage.removeItem(COUPON_KEY);
    } catch (e) {}
    render();
  }

  function checkout() {
    const t = computeTotals(state.cart);
    if (!t.count) return;
    closeDrawer();
    if (state.couponCode && findCoupon(state.couponCode)) {
      window.location.href =
        '/discount/' + encodeURIComponent(state.couponCode) + '?redirect=' + encodeURIComponent('/checkout');
      return;
    }
    window.location.href = CONFIG.checkoutUrl || '/checkout';
  }

  function onDrawerClick(e) {
    const btn = e.target.closest('[data-act]');
    if (!btn) return;
    const act = btn.getAttribute('data-act');
    const key = btn.getAttribute('data-key');
    if (act === 'close') return closeDrawer();
    if (act === 'checkout') return checkout();
    if (act === 'inc') return changeLine(key, (state.cart.items.find((i) => i.key === key)?.quantity || 0) + 1);
    if (act === 'dec') {
      const q = (state.cart.items.find((i) => i.key === key)?.quantity || 0) - 1;
      return changeLine(key, Math.max(0, q));
    }
    if (act === 'rm') return changeLine(key, 0);
    if (act === 'up-add') return addItems([{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }]).then(() => toast('Added to cart'));
    if (act === 'apply-input') {
      const f = document.getElementById('demetosCouponField');
      return applyCoupon(f ? f.value : '');
    }
    if (act === 'rm-coupon') return removeCoupon();
  }

  els.overlay.addEventListener('click', (e) => {
    if (e.target === els.overlay) closeDrawer();
  });
  els.inner.addEventListener('click', onDrawerClick);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && els.drawer.classList.contains('open')) closeDrawer();
  });

  window.DemetosCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: fetchCart,
    render,
    addItems: async (items, openAfter) => {
      await addItems(items);
      if (openAfter !== false) openDrawer();
    },
  };

  fetchCart()
    .then(render)
    .catch(() => {});

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'demetos-mood' || event?.source === 'external-refresh') {
        fetchCart().then(render).catch(() => {});
        return;
      }
      fetchCart()
        .then(() => {
          render();
          if (event?.source === 'product-form') openDrawer();
        })
        .catch(() => {});
    });
  }

  document.addEventListener('cart:updated', () => {
    fetchCart().then(render).catch(() => {});
  });
})();
